export default "__VITE_ASSET__BMBKObjU__"